/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const BW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    height="300"
    viewBox="0 0 500 300"
    {...props}
  >
    <path
      fill="#F9C700"
      d="M0 0h500v300H0z"
    />
    <path d="M0 0h500v150H0z" />
  </svg>
);
export default memo(BW);
